import * as React from 'react';

import { ClientLogger } from 'bernie-client';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

import { PropertyListingBadgeModel } from 'models';

import { UitkBadge, UitkBadgeTheme } from 'uitk-react-badge';

interface RenderBadgeProps {
  propertyListingBadgeModel: PropertyListingBadgeModel;
  travelAd: {
    impressionTrackingUrl: string;
  };
  displaySecondaryBadge: boolean;
}

const travelAdImpressions = [];
export const TitleBadge: React.FunctionComponent<RenderBadgeProps> = ({ propertyListingBadgeModel, travelAd, displaySecondaryBadge }) => {
  const { primary, secondary } = { ...propertyListingBadgeModel };
  const { impressionTrackingUrl } = { ...travelAd };
  if (impressionTrackingUrl && !travelAdImpressions.includes(impressionTrackingUrl)) {
    travelAdImpressions.push(impressionTrackingUrl);
    fetch(impressionTrackingUrl).catch(() => {
      const logger = ClientLogger.getLoggerWithIdentifier('pwa.component.title-badge');
      logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'TRAVELAD_IMPRESSION_FAILURE'), ' URL=[' + impressionTrackingUrl + ']');
    });
  }

  return (
    <React.Fragment>
      {primary &&
        (primary.text || primary.icon) && (
          <UitkBadge
            className="title__badge all-t-margin-two"
            icon={primary.icon}
            text={primary.text}
            theme={UitkBadgeTheme[primary.theme]}
          />
        )}
      {displaySecondaryBadge &&
        secondary &&
        (secondary.text || secondary.icon) && (
          <UitkBadge theme={UitkBadgeTheme[secondary.theme]} text={secondary.text} className="title__badge title__badge-details" />
        )}
    </React.Fragment>
  );
};

TitleBadge.displayName = 'TitleBadge';
